import { useState } from 'react';
import { ResetPasswordForm } from './reset-password-form';
import { ResetPasswordPhoneForm } from './reset-password-phone-form';
import { cn } from '@/utils/tailwind';

interface Props {
  isMypage?: boolean;
  onCompleted?: () => void;
  onCanceled?: () => void;
}

export const ResetPasswordContainer = ({ isMypage = false, onCompleted, onCanceled }: Props) => {
  const [step, setStep] = useState<0 | 1>(0);
  const [verificationToken, setVerificationToken] = useState<string>();

  return (
    <div
      className={cn(
        'flex h-[426px] w-[480px] flex-col items-center gap-[104px] rounded-[20px] bg-white p-10 text-left max-md:w-full max-md:p-5',
        { 'h-fit w-full p-0': isMypage },
      )}
    >
      {step === 0 && (
        <ResetPasswordPhoneForm
          verificationToken={verificationToken}
          onChangeVerificationToken={setVerificationToken}
          onNext={() => setStep(1)}
          isMypage={isMypage}
          onCanceled={onCanceled}
        />
      )}
      {step === 1 && (
        <ResetPasswordForm
          verificationToken={verificationToken}
          isMypage={isMypage}
          onCompleted={onCompleted}
          onCanceled={onCanceled}
        />
      )}
    </div>
  );
};
